interface ImageRes {
	width: number;
	height: number;
}
export const isRatioEqual = (base: ImageRes, img: ImageRes) => {
	const baseRatio = (base.width / base.height).toFixed(2);
	const imgRatio = (img.width / img.height).toFixed(2);
	return baseRatio === imgRatio;
};
